import { render, staticRenderFns } from "./chargeMoney-back.vue?vue&type=template&id=0b054380&scoped=true&"
import script from "./chargeMoney-back.vue?vue&type=script&lang=js&"
export * from "./chargeMoney-back.vue?vue&type=script&lang=js&"
import style0 from "./chargeMoney-back.vue?vue&type=style&index=0&id=0b054380&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b054380",
  null
  
)

export default component.exports